var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.aspecto
    ? _c(
        "section",
        [
          _c("metadatos", {
            ref: "metadatosForm",
            attrs: {
              "force-edit": true,
              "hide-save-button": true,
              metadatos: _vm.metadatos,
              aspecto: _vm.aspecto,
              "read-only": false,
              "can-edit": true,
              bordered: true,
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-success is-fullwidth",
              on: { click: _vm.submit },
            },
            [
              _c("i", { staticClass: "fas fa-paper-plane" }),
              _vm._v(" Guardar\n  "),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }